import {
    type CreateDriveFolderResponseType,
    type CreateDriveFolderRequestType
} from "./type";
import {
    request
} from "../request";

const CreateDriveFolder = async (params: CreateDriveFolderRequestType): Promise<CreateDriveFolderResponseType> => {
    return await request<CreateDriveFolderResponseType>("/drive/createDriveFolder", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateDriveFolder;
